/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  
  // Custom JS
  $('.search-submit').wrap( "<span class='search-btn'></span>" );
  $('.search-btn').on('click', function() {
      $('.search-form').submit();
  });
  
  $('.sub-menu > li').mouseenter(function(){
      $(this).closest('ul').parent('li.menu-item').addClass('hovered');
  });
  
  $('.sub-menu > li').mouseleave(function(){
      $(this).closest('ul').parent('li.menu-item').removeClass('hovered');
  });
  
  $('#menu-main-navigation > li').mouseenter(function(){
    $('#menu-main-navigation > li').removeClass('hovered');
    if ( $(this).has(".sub-menu")  ){
        $(this).addClass('hovered');
    }
  });
 
  $('#menu-main-navigation > li').mouseleave(function(){
    $('#menu-main-navigation > li').removeClass('hovered');
  });
  
  $("#owl-demo").owlCarousel({
      navigation : true,
      navigationText: ["<div class='slider-arrow-left'></div><div class='slider-button-text'>PREVIOUS</div>", "<div class='slider-arrow-right'></div><div class='slider-button-text'>NEXT</div>"],
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true,
      items : 1,
      autoPlay : false,
      stopOnHover : true,
      infiniteScroll: true
  });
  
  $("#owl-carousel").owlCarousel({
      navigation : true,
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem: false,
      items: 4,
      autoPlay : false,
      stopOnHover : true,
      infiniteScroll: true
  });
  
  $(window).load(function() {
    $(".imgLiquidFill").imgLiquid();
    // equalheight('.post-image-wrap');
    equalheight('.post-title');
    equalheight('.video-wrap');
    // equalheight('.slide-panels-nav li .name');
    equalheight('.report-pdf .pdf-info > h4');
    equalheight('.report-pdf');

    $('.gallery').prepend('<div class="grid-sizer"></div><div class="gutter-sizer"></div>');
    $('.gallery').addClass('masonry');
    $('.gallery .gallery-item').addClass('item');
    
    $('.masonry').masonry({
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      itemSelector: '.item'
    });
    
    $('.gallery').masonry({
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      itemSelector: '.gallery-item'
    });
    
  });
  
  $(window).resize(function(){
    // equalheight('.post-image-wrap');
    equalheight('.post-title');
    equalheight('.video-wrap');
    // equalheight('.slide-panels-nav li .name');
    equalheight('.report-pdf .pdf-info > h4');
    equalheight('.report-pdf');
  });
  
  // $('.multiple-event .nav-tabs a[data-toggle="tab"').on('shown.bs.tab', function (e) {
  //   equalheight('.slide-panels-nav li .name');
  // });
  
  function new_map( $el ) {
      // var
      var $markers = $el.find('.marker');
      // vars
      var args = {
      	zoom		: 16,
      	center		: new google.maps.LatLng(0, 0),
      	mapTypeId	: google.maps.MapTypeId.ROADMAP,
      	scrollwheel: false,
      	scaleControl: false,
        draggable: false
      };
      // create map	        	
      var map = new google.maps.Map( $el[0], args);
      
      // add a markers reference
      map.markers = [];
      
      // add markers
      $markers.each(function(){
        	add_marker( $(this), map );
      });
      
      // center map
      center_map( map );
      // return
      return map;
  }
    
  function add_marker( $marker, map ) {
    	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    	var marker = new google.maps.Marker({
    		position	: latlng,
    		map			: map
    	});
    
    	map.markers.push( marker );
    
    	if( $marker.html() )
    	{
    		var infowindow = new google.maps.InfoWindow({
    			content		: $marker.html()
    		});
    
    		google.maps.event.addListener(marker, 'click', function() {
    			infowindow.open( map, marker );
    		});
    	}
  }

  function center_map( map ) {
    	var bounds = new google.maps.LatLngBounds();
    	
    	$.each( map.markers, function( i, marker ){
    		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    		bounds.extend( latlng );
    	});
    
    	if( map.markers.length === 1 )
    	{
    	    map.setCenter( bounds.getCenter() );
    	    map.setZoom( 16 );
    	}
    	else
    	{
    		map.fitBounds( bounds );
    	}
  }
  
  equalheight = function(container){
  
    var currentTallest = 0;
    var currentRowStart = 0;
    var rowDivs = [];
    var $el;
    var topPosition = 0;
    var currentDiv;
    
    $(container).each(function() {
    
       $el = $(this);
       $($el).height('auto');
       topPosition = $el.position().top;
    
       if (currentRowStart !== topPosition) {
         for ( currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPosition;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
       for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
     });
    };
  
  $(document).ready(function(){
    $('.venobox').venobox({autoplay: 1}); 
    $("#lightgallery").lightGallery({thumbnail:true});
    
    var map = null;
    if ( $('.acf-map').length ){
      $('.acf-map').each(function(){
        map = new_map( $(this) );
      });
    }
    
    if (location.href.indexOf('#') > -1)
    {
      location.href+='';
    }
    
    $('.wpcf7-form-control.wpcf7-select').each(function(){
      var name = $(this).attr('name');
      if($(this).hasClass('sector_you_work')){
        $(this).find("option:first").text('In which sector do you work?'); 
      } else if($(this).hasClass('hear_about_event')){
        $(this).find("option:first").text('How did you hear about the event?'); 
      } else {
        $(this).find("option:first").text('Select '+name); 
      }
    });
    
    $(".modal").each(function( index ) {
      var id = $(this).attr('id');
      var $form = $(this).find('.wpcf7-form');
      
      if ( $($form).find('.wpcf7-response-output').hasClass('wpcf7-validation-errors') ){
        $('#'+id).modal('show');
      }
    });
    
    $('.modal button.close').click(function() {
      var type = window.location.hash.substr(1);
      
      if (type.length){
        if ( type.search("wpcf7") != -1 ){
          parent.location.hash = '';
          window.location.href=window.location.href.slice(0, -1);
        }
    
      }
    });
    // end contact forms
    
    $(window).scroll(function(e){
        if ($(this).scrollTop() > 100) {
        	$('.scrollToTop').fadeIn();
        } else {
        	$('.scrollToTop').fadeOut();
        }
        
        /*$('.eng-section').each(function(){
          if ( $(this).offset().top < window.pageYOffset + 10 && $(this).offset().top + $(this).height() > window.pageYOffset + 10 ) {
            var yScroll=document.body.scrollTop || document.documentElement.scrollTop;
            window.location.hash = $(this).attr('id');
            window.scroll(0, yScroll);
          }
        });*/
        
    });
      
    //Click event to scroll to top
    $('.scrollToTop').click(function(){
      $('html, body').animate({scrollTop : 0},800);
      return false;
    });
      
    if($('.wspsc_cart_coupon_row .wpspsc_coupon_section .wpspsc_coupon_label').length > 0){
      $('.wspsc_cart_coupon_row .wpspsc_coupon_section .wpspsc_coupon_label').text('If you have been given a discount code enter it here (Optional)');
    }
      
  });
  
  $('.flip').click(function(){
    $('.cont-flip').toggleClass('flipped');
    return false;
  });
  
  $('table.paginated').each(function() {
      var currentPage = 0;
      var numPerPage = 7;
      var $table = $(this);
      $table.bind('repaginate', function() {
          $table.find('tbody tr').hide().slice(currentPage * numPerPage, (currentPage + 1) * numPerPage).show();
      });
      $table.trigger('repaginate');
      var numRows = $table.find('tbody tr').length;
      var numPages = Math.ceil(numRows / numPerPage);
      var $pager = $('<div class="pager"></div>');
      for (var page = 0; page < numPages; page++) {
          $('<span class="page-number"></span>').text(page + 1).bind('click', {
              newPage: page
          }, function(event) {
              currentPage = event.data['newPage'];
              $table.trigger('repaginate');
              $(this).addClass('active').siblings().removeClass('active');
          }).appendTo($pager).addClass('clickable');
      }
      $pager.insertAfter($table).find('span.page-number:first').addClass('active');
  });
  
  $('#menu-main-navigation > li > a').click(function(e) {
    
    if ( $( window ).width() <= 767 ){
      e.preventDefault();
      e.stopPropagation();
      
      if ( $(this).next('.sub-menu').hasClass('shown') ){
        $(this).next('.sub-menu').removeClass('shown').hide();
      }else{
        $('.navbar-collapse.collapse .sub-menu').hide();
        $(this).next('.sub-menu').addClass('shown').show(); 
      }
    }
    
  });  
  
  $('#mobile-toggle').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#menu-main-navigation').width($(window).width()+'px').height($(window).height()+'px');
    $("#menuNav").slideToggle( "slow" );
    $('#navbar-burger').toggleClass('hidden');
    $('#navbar-close').toggleClass('hidden');
    $('body').toggleClass('no-scroll');
  });
  
  var attendIsReady = false;
  var isVisitor     = false;
  if($(".visitor-mode-on").length > 0){
    isVisitor = true;
  }
  $('.shopping_cart .wpspsc_checkout_form form').submit(function(e){
    if (!isVisitor && !$(".logged-cart-form-wrap form").find('.wpcf7-response-output').hasClass('wpcf7-mail-sent-ok')){
      e.preventDefault();
      $('.logged-cart-form-wrap form').submit();
    }
    else if (!attendIsReady && isVisitor){
      e.preventDefault();
      $('.cart-form-wrap form #cart-submit').trigger('click');
    } 
    else if ( attendIsReady && isVisitor && window.location.href.indexOf("validation") > -1 ) {
      $(".shopping_cart .wpspsc_checkout_form form").submit();
    } 
    else if ( $('.cart-0-total').length > 0 ) {
      e.preventDefault();
      window.location = $('.cart-0-total').text();
    } 
    else {
      $('#paypal-loader').removeClass('hidden');
    }
  });
  
  function fill_form(){
    if ( values && values != 'null' ){
      var val = JSON.parse(values);
      //console.log(val);
      $.each(val, function(key, value) {
          // console.log(key, value);
          $(".cart-form-wrap form .wpcf7-form-control[name="+key+"]").val(value);
      });
      $(".cart-form-wrap form .wpcf7-form-control[name=terms]").prop( "checked", true );
    }
  }
  
  function check_form_qty(){
    var flag = false;
    if ( values && values != 'null' ){
      var val = JSON.parse(values);
      if ( $(".cart-form-wrap form input[name=tickets_quantity]").val() != val.tickets_quantity ) {
        $('.cart-form-wrap form #cart-submit').trigger('click');
      }
    }
  }
  
  $(window).load(function() {
    var val = '';
    var qty = 0;
    $(".cart-wrap .wspsc_cart_item_thumb").each(function( index ) {
      if (val!='')
        val = val+', '+$(this).find('.wp_cart_item_name').children('a').text();
      else
        val = $(this).find('.wp_cart_item_name').children('a').text();
      
      qty=qty+parseInt($(this).find('input[name="quantity"]').val());
    });
    
    $(".cart-form-wrap form").append('<input type="hidden" name="event_information" value="'+val+'">\
    <input type="hidden" name="tickets_quantity" value="'+qty+'">');
    $(".logged-cart-form-wrap form").append('<input type="hidden" name="event_information" value="'+val+'">\
    <input type="hidden" name="tickets_quantity" value="'+qty+'">');
    
    if (isVisitor){
      $('.cart-form-wrap #terms-link-target').attr('href',$('.cart-form-wrap').attr('data-terms-link'));
      
      if ( $('.cart-wrap').hasClass('valid') ){
        $('input[name="quantity"]').prop( "disabled", true );
        $('input[type="image"]').addClass('hidden');
        $('.cart-wrap.valid .wspsc_cart_coupon_row').show();
        $('.cart-wrap.valid .wpspsc_checkout_form').show();
        $('.cart-wrap.valid .shopping_cart').next('p').show();
        $('.cart-wrap.valid .wp_cart_checkout_button').removeClass('hidden');
        fill_form();
        check_form_qty();
        attendIsReady = true;
      }
      
      if ( $(".cart-form-wrap form").find('.wpcf7-response-output').hasClass('wpcf7-mail-sent-ok') ){
        attendIsReady = true;
      }else{
        if ( !$('.cart-wrap').hasClass('valid') ){
          $('.cart-wrap .wspsc_cart_coupon_row').hide();
          $('.cart-wrap .wpspsc_checkout_form').hide();
          $('.cart-wrap .shopping_cart').next('p').hide();
        }
      }
    } else {
      if ($(".logged-cart-form-wrap form").find('.wpcf7-response-output').hasClass('wpcf7-mail-sent-ok')){
      	$(".shopping_cart .wpspsc_checkout_form form").submit();
      }
    }
    
    $('.form_back').click(function(e) {
      e.preventDefault();
      $('#form_event_wrap').removeClass('hidden');
      $('input[name="quantity"]').prop( "disabled", false );
      $('input[type="image"]').removeClass('hidden');
      $('.cart-wrap .wspsc_cart_coupon_row').hide();
      $('.cart-wrap .wpspsc_checkout_form').hide();
      $('.cart-wrap .shopping_cart').next('p').hide();
      $('.wpcf7-response-output').remove();
    });
    
    if($('.wspsc_cart_coupon_row .wpspsc_coupon_section .wpspsc_coupon_label').length > 0){
      $('.wspsc_cart_coupon_row .wpspsc_coupon_section .wpspsc_coupon_label').text('If you have been given a discount code enter it here (Optional)');
    }
    
  });
  
  var multiple_days = [];
  var multiple_prices = [];
  var event = {};
  var cart_p_key = '';
  $('.attend2event-wrap button').click(function(){
    if ( !$(this).hasClass('multiple-select') ) {
      var parent = $(this).closest('.attend2event-wrap');
      parent.find('.form-wrap form').submit();
    }else {
      // multiple_days
      var id = $(this).data('id');
      var data = { 'action': 'get_post', 'id': id };
      
      if (id) {
        $('#select_days').data('id', id);
      	jQuery.post(ajaxurl, data, function(response) {
      	  if (response) {
        	  var data = JSON.parse(response);
        	  //console.log(data);
        	  
        	  cart_p_key = data.cart_p_key;
        	  
        	  event = data.event;
        	  
            $('#select_days .mutliSelect').empty();
            
            if (data.days.length > 0) {
              multiple_days = data.days; // store days
              
              $('#select_days .mutliSelect').append('<li class="select_all '+(data.event.sold_out == true ? 'sold_out': '')+'"><div class="checkbox">\
                  <label>\
                      <input type="checkbox" value="all" '+(data.event.sold_out == true ? 'disabled': '')+'>\
                      <span>All Days - TOTAL PRICE &pound;'+data.event.price+' '+(data.event.sold_out == true ? '(SOLD OUT)': '')+'</span>\
                  </label>\
              </div></li>');
              
              if (data.price_groups.length > 0) { // multiple_prices
                multiple_prices = data.price_groups;
                $.each(data.price_groups, function( index, value ) {
                  $('#select_days .mutliSelect').append('<li><div class="checkbox">\
                      <label>\
                          <input type="checkbox" value="'+value.id+'" class="multiple_price">\
                          <span>'+value.label+' ('+value.label_days.join(", ")+')'+'\
                            - &pound; '+value.price+'</span>\
                      </label>\
                  </div></li>');
                });
              }
              
          	  $.each(data.days, function( index, value ) {
                $('#select_days .mutliSelect').append('<li class="'+(value.sold_out == true ? 'sold_out': '')+'"><div class="checkbox">\
                    <label>\
                        <input type="checkbox" value="'+value.id+'" '+(value.sold_out == true ? 'disabled': '')+'>\
                        <span>'+value.date+(value.end_date!='' ? ' - '+value.end_date : '')+'\
                          '+(value.start_time!='' ? ', '+value.start_time : '')+(value.end_time!='' ? ' - '+value.end_time : '')+'\
                          - &pound; '+value.price+' '+(value.sold_out == true ? '(SOLD OUT)': '')+'</span>\
                    </label>\
                </div></li>');
              });
            }else{
              $('#select_days .multiple-cnt').prop( "disabled", true);
              $('#select_days .mutliSelect').append('There are no availiable days for this event.');  
            }
            
        		$('#select_days').modal('show');
      	  }
      	});
      }
    }
  });
  
  $('#select_days').on('click', '.select_all input[type="checkbox"]', function(){
    var $this = $(this);
    if ($this.is(":checked")) {
      $('.multiple-errors').hide().empty();
      $('#select_days input[type="checkbox"]').each(function( index ) {
        $(this).not($this).prop('disabled', true);
      });
    }else {
      $('#select_days input[type="checkbox"]').each(function( index ) {
        if (!$(this).closest('li').hasClass('sold_out'))
          $(this).prop('disabled', false);
      });
    }    
  });
  
  $('#select_days .multiple-cnt').click(function() {
    var id = $('#select_days').data('id');
    var data = { 'action': 'multiple_event', 'id': id, 'selected': [], 'all': 0 };
    
    if (id) {
      $('#select_days input[type="checkbox"]').each(function( index ) {
        var $this = $(this);
        
        if ($this.is(":checked") && !$this.is(':disabled')) {
          data.event = event;
          
          if ($this.val() == 'all') {
            data.all = 1;
            return 0;
          }else {
            if ($this.hasClass('multiple_price')) {
              $.each(multiple_prices, function( i, value ) {
                if ( $this.val() == value.id ) {
                  data.selected.push({
                    id: $this.val(),
                    dates: value.label_days,
                    label: value.label,
                    price: value.price
                  });  
                }
              });  
            }else {
              $.each(multiple_days, function( i, value ) {
                if ( $this.val() == value.id && value.sold_out == false ) {
                  data.selected.push({
                    id: $this.val(),
                    date: value.date,
                    end_date: value.end_date,
                    start_time: value.start_time,
                    end_time: value.end_time,
                    price: value.price
                  });  
                }
              });
            }
            
          }
        }  
      });
      
      if (data.selected.length == 0 && data.all == false) {
        $('.multiple-errors').show().text('Please select a day');
      }else {
        $('.multiple-errors').hide().empty();
        $(this).prop( "disabled", true);
        //console.log(data)
        jQuery.post(ajaxurl, data, function(response) {
          var cart_data_array = JSON.parse(response);
          //console.log(response);
      	  if (cart_data_array.length > 0) {
      	    var count = 0;
        	  $.each(cart_data_array, function( i, cart_item ) {
              jQuery.post(ajaxurl, cart_item, function(res) {
                //console.log(i);
                if(res.indexOf("Error") >= 0){
                  console.log(res);
                } else if(res == 0){
                  console.log("admin-ajax failed");
                } else {
                  //console.log("succeeded");
                  count++;
                }
                if(i == cart_data_array.length - 1 && count > 0){
                  //console.log("going to cart");
                  window.location = '/?page_id=1642';
                }
            	});
        	  });
      	  }
      	});
      }
    }
  });
  
  $('#select_days').on('hidden.bs.modal', function () {
    multiple_days = [];
    multiple_prices = [];
    event = [];
    $('#select_days .multiple-cnt').prop( "disabled", false);
    $('#select_days .mutliSelect').empty();
    $('.multiple-errors').hide().empty();
  });
  
  
  if ($('#add-event-to-calendar').length) {
    var $el = $('#add-event-to-calendar');
    
    var data = {
      title: $el.data('title')
    };
    
    if ($el.data('start') !== '' && $el.data('start_time')) { 
      data.start = new Date($el.data('start') + ' ' + $el.data('start_time'));
    }
    
    if ($el.data('end') !== '' && $el.data('end_time')) {
      data.end = new Date($el.data('end') + ' ' + $el.data('end_time'));
    } else if ($el.data('start') !== '' && $el.data('end_time')) {
      data.end = new Date($el.data('start') + ' ' + $el.data('end_time'));
    }
    
    
    if ($el.data('address') !== '') {
      data.address = $el.data('address');
    } 
    
    if (data.start && data.end) {
      var eventCalendar = createCalendar({
        options: {
          class: 'event-calendar'
        },
        data: data
      });
      
      document.querySelector('#add-event-to-calendar').appendChild(eventCalendar);
    } else {
      $el.hide();
    }
    
    $('#add-event-to-calendar .btn-calendar').click(function(event) {
      event.stopPropagation();
      $(this).next('.event-calendar').show();
    });
    
    $(document).click(function() {
      if ($('.event-calendar').css('display') === 'block') {
        $('.event-calendar').hide();
      }
    });
  }
  
})(jQuery); // Fully reference jQuery after this point.
